import { KProperty02ce7r476m8633 as KProperty0 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { AppendableFormatStructure38mt32f1b8qva as AppendableFormatStructure } from '../internal/format/Builder.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  appendAlternativeParsingImpl1mug8j87kp2j3 as appendAlternativeParsingImpl,
  appendOptionalImplcg29ds00y54b as appendOptionalImpl,
  chars1g48a4lypizqb as chars,
  build284bs2tzkjm2x as build,
  year$defaulto1ef087ubfdc as year$default,
  monthNumber$default3k7qk403bnffp as monthNumber$default,
  dayOfMonth$default2fd2gjqoxzh9x as dayOfMonth$default,
  hour$default28zjolx0s9fg0 as hour$default,
  minute$defaultoouhhkuji8pa as minute$default,
  second$default25cj8g9tgx4nm as second$default,
  AbstractDateTimeFormatBuilder2kkelk07l4wb as AbstractDateTimeFormatBuilder,
  WithDate2bqihss8t5xfv as WithDate,
  WithTime2lgb7k6hqa1zi as WithTime,
  alternativeParsing1gmwubnsvpp9b as alternativeParsing,
  char1r4ssccmdfesy as char,
} from './DateTimeFormatBuilder.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  year2o42o5s31g3p8 as year,
  monthNumber39ajqip9c32rn as monthNumber,
  monthNames1ujl7xt4e7x as monthName,
  dayOfMonths8rfgqv9djoz as dayOfMonth,
  dayOfWeek16trujebvwhwq as dayOfWeek,
  date3ki45iw426xr8 as date,
  IncompleteLocalDate2wlnrm8wqbjky as IncompleteLocalDate,
  AbstractWithDateBuilder1xwo9aqwqe32f as AbstractWithDateBuilder,
  get_ISO_DATE1ah0stqy13618 as get_ISO_DATE,
} from './LocalDateFormat.mjs';
import {
  hour31jxjrzfyqe0i as hour,
  amPmHour1hvi7u14xj951 as amPmHour,
  amPmMarker15xvjzra6ar5a as amPmMarker,
  minute2dqmds23fogn6 as minute,
  secondq4lhw2ppe1iv as second,
  secondFraction17r4cie9ncxw as secondFraction,
  time3kvfctmdykstm as time,
  IncompleteLocalTime3h4nusjwtlckd as IncompleteLocalTime,
  TimeFieldContainer3bsvpq7sk70go as TimeFieldContainer,
  AbstractWithTimeBuilder2vqnew72ok0ro as AbstractWithTimeBuilder,
  get_ISO_TIME31n00f6uljtbs as get_ISO_TIME,
} from './LocalTimeFormat.mjs';
import { AbstractDateTimeFormat1er9ki1vjeb1b as AbstractDateTimeFormat } from './DateTimeFormat.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { LocalDateTime3vqv9moe7clf4 as LocalDateTime } from '../LocalDateTime.mjs';
import { _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_ISO_DATETIME() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  var tmp0 = ISO_DATETIME$delegate;
  var tmp = KProperty0();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('ISO_DATETIME', 0, tmp, _get_ISO_DATETIME_$ref_5bxm11(), null);
  return tmp0.f2();
}
var ISO_DATETIME$delegate;
function get_emptyIncompleteLocalDateTime() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  return emptyIncompleteLocalDateTime;
}
var emptyIncompleteLocalDateTime;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      j1w(block) {
        var builder = new (Builder())(new (AppendableFormatStructure())());
        block(builder);
        return new (LocalDateTimeFormat())(builder.m1r());
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(actualBuilder) {
        this.k1w_1 = actualBuilder;
      }
      o1s() {
        return this.k1w_1;
      }
      p1s(structure) {
        this.k1w_1.r1s(structure);
      }
      t1s() {
        return new (Builder())(new (AppendableFormatStructure())());
      }
    }
    protoOf($).u1s = appendAlternativeParsingImpl;
    protoOf($).v1s = appendOptionalImpl;
    protoOf($).g1r = chars;
    protoOf($).m1r = build;
    protoOf($).w1s = addFormatStructureForDate;
    protoOf($).x1s = addFormatStructureForTime;
    protoOf($).y1s = year;
    protoOf($).f1r = year$default;
    protoOf($).z1s = monthNumber;
    protoOf($).a1t = monthNumber$default;
    protoOf($).e1r = monthName;
    protoOf($).b1r = dayOfMonth;
    protoOf($).b1t = dayOfMonth$default;
    protoOf($).j1r = dayOfWeek;
    protoOf($).u1q = date;
    protoOf($).c1t = hour;
    protoOf($).v1q = hour$default;
    protoOf($).d1t = amPmHour;
    protoOf($).e1t = amPmMarker;
    protoOf($).f1t = minute;
    protoOf($).w1q = minute$default;
    protoOf($).g1t = second;
    protoOf($).x1q = second$default;
    protoOf($).y1q = secondFraction;
    protoOf($).h1t = time;
    initMetadataForClass($, 'Builder', VOID, VOID, [AbstractDateTimeFormatBuilder(), AbstractWithDateTimeBuilder()]);
    BuilderClass = $;
  }
  return BuilderClass;
}
var LocalDateTimeFormatClass;
function LocalDateTimeFormat() {
  if (LocalDateTimeFormatClass === VOID) {
    class $ extends AbstractDateTimeFormat() {
      constructor(actualFormat) {
        super();
        this.l1w_1 = actualFormat;
      }
      o1t() {
        return this.l1w_1;
      }
      m1w(value) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (IncompleteLocalDateTime())();
        this_0.p1w(value);
        return this_0;
      }
      q1t(value) {
        return this.m1w(value instanceof LocalDateTime() ? value : THROW_CCE());
      }
      q1w(intermediate) {
        return intermediate.r1w();
      }
      s1t(intermediate) {
        return this.q1w(intermediate instanceof IncompleteLocalDateTime() ? intermediate : THROW_CCE());
      }
      t1t() {
        return get_emptyIncompleteLocalDateTime();
      }
    }
    initMetadataForClass($, 'LocalDateTimeFormat');
    LocalDateTimeFormatClass = $;
  }
  return LocalDateTimeFormatClass;
}
var IncompleteLocalDateTimeClass;
function IncompleteLocalDateTime() {
  if (IncompleteLocalDateTimeClass === VOID) {
    class $ {
      constructor(date, time) {
        date = date === VOID ? new (IncompleteLocalDate())() : date;
        time = time === VOID ? new (IncompleteLocalTime())() : time;
        this.n1w_1 = date;
        this.o1w_1 = time;
      }
      i1p(_set____db54di) {
        this.n1w_1.l1p_1 = _set____db54di;
      }
      r1o() {
        return this.n1w_1.l1p_1;
      }
      n1p(_set____db54di) {
        this.n1w_1.m1p_1 = _set____db54di;
      }
      o1p() {
        return this.n1w_1.m1p_1;
      }
      p1p(_set____db54di) {
        this.n1w_1.k1p_1 = _set____db54di;
      }
      q1o() {
        return this.n1w_1.k1p_1;
      }
      q1p(_set____db54di) {
        this.n1w_1.j1p_1 = _set____db54di;
      }
      p1o() {
        return this.n1w_1.j1p_1;
      }
      r1p(_set____db54di) {
        this.o1w_1.u1p_1 = _set____db54di;
      }
      y1p() {
        return this.o1w_1.u1p_1;
      }
      z1p(value) {
        this.o1w_1.z1p(value);
      }
      a1q() {
        return this.o1w_1.a1q();
      }
      b1q(_set____db54di) {
        this.o1w_1.s1p_1 = _set____db54di;
      }
      x1o() {
        return this.o1w_1.s1p_1;
      }
      c1q(_set____db54di) {
        this.o1w_1.t1p_1 = _set____db54di;
      }
      d1q() {
        return this.o1w_1.t1p_1;
      }
      e1q(_set____db54di) {
        this.o1w_1.v1p_1 = _set____db54di;
      }
      y1o() {
        return this.o1w_1.v1p_1;
      }
      f1q(_set____db54di) {
        this.o1w_1.x1p_1 = _set____db54di;
      }
      a1p() {
        return this.o1w_1.x1p_1;
      }
      g1q(_set____db54di) {
        this.o1w_1.w1p_1 = _set____db54di;
      }
      z1o() {
        return this.o1w_1.w1p_1;
      }
      r1w() {
        return LocalDateTime().s1w(this.n1w_1.g1s(), this.o1w_1.e1s());
      }
      p1w(dateTime) {
        this.n1w_1.h1u(dateTime.t1w());
        this.o1w_1.v1w(dateTime.u1w());
      }
      t1q() {
        return new (IncompleteLocalDateTime())(this.n1w_1.t1q(), this.o1w_1.t1q());
      }
    }
    initMetadataForClass($, 'IncompleteLocalDateTime', IncompleteLocalDateTime, VOID, [TimeFieldContainer()]);
    IncompleteLocalDateTimeClass = $;
  }
  return IncompleteLocalDateTimeClass;
}
function addFormatStructureForDate(structure) {
  this.p1s(structure);
}
function addFormatStructureForTime(structure) {
  this.p1s(structure);
}
var AbstractWithDateTimeBuilderClass;
function AbstractWithDateTimeBuilder() {
  if (AbstractWithDateTimeBuilderClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'AbstractWithDateTimeBuilder', VOID, VOID, [AbstractWithDateBuilder(), AbstractWithTimeBuilder(), WithDate(), WithTime()]);
    AbstractWithDateTimeBuilderClass = $;
  }
  return AbstractWithDateTimeBuilderClass;
}
function ISO_DATETIME$delegate$lambda() {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  var tmp = Companion_instance;
  return tmp.j1w(ISO_DATETIME$delegate$lambda$lambda);
}
function ISO_DATETIME$delegate$lambda$lambda($this$build) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  $this$build.u1q(get_ISO_DATE());
  var tmp = [ISO_DATETIME$delegate$lambda$lambda$lambda];
  alternativeParsing($this$build, tmp, ISO_DATETIME$delegate$lambda$lambda$lambda_0);
  $this$build.h1t(get_ISO_TIME());
  return Unit_instance;
}
function ISO_DATETIME$delegate$lambda$lambda$lambda($this$alternativeParsing) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(116));
  return Unit_instance;
}
function ISO_DATETIME$delegate$lambda$lambda$lambda_0($this$alternativeParsing) {
  _init_properties_LocalDateTimeFormat_kt__aloigl();
  char($this$alternativeParsing, _Char___init__impl__6a9atx(84));
  return Unit_instance;
}
function _get_ISO_DATETIME_$ref_5bxm11() {
  return () => get_ISO_DATETIME();
}
var properties_initialized_LocalDateTimeFormat_kt_67ys6r;
function _init_properties_LocalDateTimeFormat_kt__aloigl() {
  if (!properties_initialized_LocalDateTimeFormat_kt_67ys6r) {
    properties_initialized_LocalDateTimeFormat_kt_67ys6r = true;
    ISO_DATETIME$delegate = lazy(ISO_DATETIME$delegate$lambda);
    emptyIncompleteLocalDateTime = new (IncompleteLocalDateTime())();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Companion_instance as Companion_instance6qbrtyiwm67y,
  addFormatStructureForDate as addFormatStructureForDate3d5amh7zu2xvd,
  addFormatStructureForTime as addFormatStructureForTime1tqep05b2dvut,
  AbstractWithDateTimeBuilder as AbstractWithDateTimeBuilder2fkc9fus0fd8o,
  get_ISO_DATETIME as get_ISO_DATETIME2pryl9hy3c2kg,
};
//endregion

//# sourceMappingURL=LocalDateTimeFormat.mjs.map
